import { ACTIONS } from "./customerSettings.action";

export const initialState = {
  listRevision: 0,
  accountFilter: "",
};

const customerSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.REFRESH_CHAT_QUEUE_ACCOUNTS:
      return {
        ...state,
        listRevision: state.listRevision + 1,
      };
    case ACTIONS.SET_CHAT_QUEUE_ACCOUNT_FILTER:
      return {
        ...state,
        accountFilter: action.payload || "",
      };
    default:
      return state;
  }
};

export default customerSettingsReducer;
